/**
 * Whether an account may send another document for extraction right now.
 * - AVAILABLE: extraction is allowed
 * - EXHAUSTED: the payer's quota is spent; a managed client asks its master account
 */
export const ExtractionQuotaStatus = {
  AVAILABLE: 'AVAILABLE',
  EXHAUSTED: 'EXHAUSTED'
} as const;

export type ExtractionQuotaStatus =
  (typeof ExtractionQuotaStatus)[keyof typeof ExtractionQuotaStatus];
